// export const baseURl = 'http://localhost:3001'
// export const baseURl = 'https://itgomvp2fl.execute-api.us-east-2.amazonaws.com/dev'

export const baseURl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const environment = process.env.ENVIRONMENT || 'dev';
export const recaptcha_site_key = "6LffI-MgAAAAACyxWoTEVTafIL9nzFv09g4397Mg";
